export default // eslint-disable-next-line max-len
'<svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16"><path d="M302 356h-8v-2h2.927l2.116-12H296v-2h8v2h-2.927l-2.116 12H302v2Z" transform="translate(-294 -340)" style="fill-rule:evenodd"/></svg>';
